<template>
  <div v-if="table">
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <label>Número da mesa</label>
        <vs-input readonly class="w-full" icon-pack="feather" icon="icon-edit" v-model="table.number" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <label>Link direto</label>
        <vs-input class="w-full" readonly icon-pack="feather" icon="icon-link" v-model="table.shortUrl" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <label class="w-full">Acessos: </label>
        <vs-input class="w-full" readonly icon-pack="feather" icon="icon-users" :value="table.clicks || 0" v-if="table.clicks" />
        <label class="text-grey" v-else>Carregando acessos...</label>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    props: {
      tableId: {
        required: true,
        type: String
      }
    },

    computed: {
      table() {
        return this.availableTables.find(x => x.id === this.tableId)
      },

      ...mapState('tables', ['availableTables'])
    },

    watch: {
      tableId() {
        this.fetchTableClicks({ tableId: this.tableId })
      }
    },

    mounted() {
      this.fetchTableClicks({ tableId: this.tableId })
    },

    methods: {
      ...mapActions('tables', ['fetchTableClicks'])
    },
  }
</script>